import * as XLSX from "xlsx";

export default function useRelatorioXlsx() {
  const transformData = (data, columnMap) =>
    data.map((item) =>
      Object.keys(columnMap).reduce(
        (acc, key) => ({
          ...acc,
          [columnMap[key]]: item[key],
        }),
        {},
      ),
    );

  /**
   * Gera o arquivo XLSX com dados personalizados.
   * @param {Array} data - Dados originais do JSON.
   * @param {Object} columnMap - Mapeamento de colunas (chave original -> nome na planilha).
   * @param {String} fileName - Nome do arquivo gerado.
   * @param {String} sheetName - Nome da aba do Excel.
   */

  const generateXlsx = (data, columnMap, fileName, sheetName, title = "", columnWidths = []) => {
    try {
      const transformedData = transformData(data, columnMap);
      const columnHeaders = Object.values(columnMap); // Cabeçalhos das colunas
      const columnCount = columnHeaders.length;

      // Criar worksheet manualmente com título na linha 1
      const worksheet = XLSX.utils.aoa_to_sheet([[title], columnHeaders]);

      // Adicionar os dados a partir da linha 2 (evitando substituir o título)
      XLSX.utils.sheet_add_json(worksheet, transformedData, {
        origin: "A3", // Começar os dados na linha 3
        skipHeader: true, // Evitar cabeçalhos duplicados
      });

      // Mesclar as células para o título (de A1 até a última coluna)
      worksheet["!merges"] = [
        {
          s: { r: 0, c: 0 }, // Início (linha 1, coluna 1)
          e: { r: 0, c: columnCount - 1 }, // Fim (linha 1, última coluna)
        },
      ];

      // Adicionar largura de colunas
      if (columnWidths.length > 0) {
        worksheet["!cols"] = columnWidths.map((width) => ({ wch: width }));
      }

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Erro ao gerar arquivo XLSX:", error);
    }
  };

  return { generateXlsx };
}
